import type { Role } from "@sr-partner-portal/common";
import { createContext, useContext } from "react";

const UserRoleContext = createContext<null | keyof typeof Role>(null);
const UserRoleProvider = UserRoleContext.Provider;
const useUserRoleContext = () => useContext(UserRoleContext);

export { UserRoleContext, UserRoleProvider, useUserRoleContext };
